import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
import { Stars } from './Stars';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
const VISIBLE = 6;
export function TestimonialWall() {
  const [expanded, setExpanded] = useState(false);
  const visible = testimonials.slice(0, VISIBLE);
  const hidden = testimonials.slice(VISIBLE);
  return <section className="w-full bg-sand/50 py-16 sm:py-24" aria-labelledby="testimonios-title" data-id="element-369" data-mp="3du93zoe9kzqp">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-370" data-mp="2zv10ijb2j5gp">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-371" data-mp="2zwc52lcc8h8v">
          <div className="max-w-2xl" data-id="element-372" data-mp="33x4hfngib29d">
            <h2 id="testimonios-title" className="font-display text-3xl font-semibold leading-tight tracking-tight text-bark sm:text-4xl" data-id="element-373" data-mp="33y5zibvxwp0l">
              El muro de la transformación
            </h2>
            <p className="mt-4 text-base leading-relaxed text-ink/80 sm:text-lg" data-id="element-374" data-mp="122n8c112pymn">
              Lo que dicen las mujeres que dejaron de luchar contra su cuerpo.
            </p>
          </div>

          <div className="flex shrink-0 flex-col gap-3 rounded-xl border border-bark/10 bg-cream p-5 shadow-soft sm:flex-row sm:items-center sm:gap-6" data-id="element-375" data-mp="1rm4i888ggd2c">
            <div data-id="element-376" data-mp="21ethm4qqe0hb">
              <Stars size="md" label="4,9 de 5 estrellas" data-id="element-377" data-mp="21ea9ffqvuqgh" />
              <p className="mt-2 text-sm text-ink/70" data-id="element-378" data-mp="1dno4hxc6dmap">
                <span className="font-semibold text-bark" data-id="element-379" data-mp="1dqa9bp7olnp8">Excelente</span> · 4,9 de 5
              </p>
            </div>
            <span className="hidden h-12 w-px bg-bark/10 sm:block" aria-hidden="true" data-id="element-380" data-mp="1nmdmdq42n6qy" />
            <div className="text-sm text-ink/70" data-id="element-381" data-mp="1nk0v2mcfbk18">
              <p className="font-semibold text-bark" data-id="element-382" data-mp="1im90fkke9jtc">2.847 valoraciones</p>
              <p className="mt-1 inline-flex items-center gap-1.5 text-xs text-trust" data-id="element-383" data-mp="2z10vy6cu776v">
                <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-384" data-mp="2u2pmhwqgeyp6" />
                Compras verificadas
              </p>
            </div>
          </div>
        </div>

        <ul className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-385" data-mp="317qj7gydq8sn">
          {visible.map(t => <li key={t.id} data-id="element-386" data-mp="366jud2q71npn">
              <TestimonialCard testimonial={t} data-id="element-387" data-mp="3b3aatr5wulbl" />
            </li>)}
        </ul>

        <AnimatePresence initial={false} data-id="element-388" data-mp="3g2wm3v26hrhr">
          {expanded && <motion.ul key="hidden-testimonials" className="mt-5 grid grid-cols-1 gap-5 overflow-hidden sm:grid-cols-2 lg:grid-cols-3" initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-389" data-mp="3g1lgrqt34boj">
              {hidden.map((t, i) => <motion.li key={t.id} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.24,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(i * 0.04, 0.24)
          }} data-id="element-390" data-mp="2x5vd7z5i778j" data-mpi={i}>
                  <TestimonialCard testimonial={t} data-id="element-391" data-mp="hr1otbur5gw2" />
                </motion.li>)}
            </motion.ul>}
        </AnimatePresence>

        <div className="mt-10 flex justify-center" data-id="element-392" data-mp="cr5mri5m7zj5">
          <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} className="inline-flex items-center gap-2 rounded-xl border border-bark/20 bg-cream px-6 py-3.5 text-sm font-semibold text-bark shadow-soft transition-colors duration-150 ease-out hover:bg-sand focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" data-id="element-393" data-mp="ctrubhsiaf1d">
            {expanded ? 'Ver menos testimonios' : `Ver más testimonios (${hidden.length})`}
            <ChevronDownIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${expanded ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-394" data-mp="3l8jp8y873lmg" />
          </button>
        </div>
      </div>
    </section>;
}